const resolveLang = () => {
    const raw = (localStorage.getItem("language") || process.env.REACT_APP_LANGUAGE || "it").toLowerCase();
    if (raw.startsWith("it")) return "it";
    return "en";
};

const modalTexts = {
    it: {
        missingRequiredTitle: "Campi obbligatori mancanti",
        missingRequiredIntro: "Compila tutti i campi prima di salvare questo nuovo record:",
        discardChangesTitle: "Scartare le modifiche?",
        discardChangesText: "Hai modifiche non salvate. Sei sicuro di volerle scartare?",
        discardConfirm: "Sì, scarta",
        discardCancel: "No, continua a modificare",
        fetchVocabularyDataError: "Errore nel recupero dei dati del vocabolario",
        recordSavedSuccessTitle: "Record salvato con successo",
        recordSavedSuccessText: "Il record è stato salvato con successo",
        recordSavedFailedTitle: "Errore nel salvataggio del record",
        recordSavedFailedText: "Il record non è stato salvato",
        noChangesTitle: "Nessuna modifica",
        noChangesText: "Nessuna modifica da salvare",
        saveChangesTitle: "Salvare le modifiche?",
        saveChangesConfirm: "Sì, salva tutto!",
        saveChangesCancel: "No, annulla",
        saveChangesHtml: (count) => `
              <p>Stai per salvare <strong>${count}</strong> record(s).</p>
              <p class="text-muted small">Questa operazione verrà eseguita come una singola transazione atomica.</p>
            `,
        validationFailedTitle: "Validazione fallita",
        validationFailedHtml: (count, errorRows) => `
          <div class="text-start">
            <p class="mb-2"><strong>${count}</strong> record(s) hanno campi obbligatori mancanti:</p>
            <div style="max-height: 300px; overflow-y: auto;">
              <table class="table table-sm table-bordered">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 80px;">Record</th>
                    <th style="width: 120px;">ID</th>
                    <th>Campi obbligatori mancanti</th>
                  </tr>
                </thead>
                <tbody>
                  ${errorRows}
                </tbody>
              </table>
            </div>
            <p class="mt-2 mb-0 text-muted small">Compila i campi evidenziati e prova di nuovo.</p>
          </div>
        `,
        bulkUpdateCompletedWithErrorsTitle: "Aggiornamento bulk completato con errori",
        bulkUpdateCompletedWithErrorsHtml: (results, errorRows) => `
              <div class="text-start">
                <div class="alert alert-success mb-3">
                  <p class="mb-0"><strong>Aggiornati:</strong> ${results.updated} record(s)</p>
                </div>
                <div class="alert alert-danger mb-3">
                  <p class="mb-0"><strong>Falliti:</strong> ${results.failed} record(s)</p>
                </div>
                <div style="max-height: 300px; overflow-y: auto;">
                  <table class="table table-sm table-bordered">
                    <thead class="table-light sticky-top">
                      <tr>
                        <th style="width: 80px;">Record</th>
                        <th style="width: 120px;">ID</th>
                        <th>Errore</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${errorRows}
                    </tbody>
                  </table>
                </div>
              </div>
            `,
        bulkUpdateSuccessTitle: "Successo",
        bulkUpdateSuccessText: "record(s) salvati con successo",
        bulkUpdateFailedTitle: "Aggiornamento bulk fallito",
        bulkUpdateFailedHtml: (response, results, errorRows) => `
          <div class="text-start">
            <div class="alert alert-danger mb-3">
              <p class="mb-0"><strong>${response.message || 'Tutti i record non sono stati salvati'}</strong></p>
            </div>
            <div class="alert alert-info mb-3">
              <p class="mb-1"><strong>Creati:</strong> ${results.created || 0} record(s)</p>
              <p class="mb-1"><strong>Aggiornati:</strong> ${results.updated || 0} record(s)</p>
              <p class="mb-0"><strong>Falliti:</strong> ${results.failed || 0} record(s)</p>
            </div>
            <div style="max-height: 300px; overflow-y: auto;">
              <table class="table table-sm table-bordered">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 80px;">Record</th>
                    <th style="width: 120px;">ID</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  ${errorRows}
                </tbody>
              </table>
            </div>
          </div>
        `,
        validationErrorNoObjectHtml: (response, errorList) => `
              <div class="text-start">
                <p class="mb-2">${response.message || 'Correggi i seguenti errori:'}</p>
                <ul class="list-unstyled">
                  ${errorList}
                </ul>
              </div>
            `,
        bulkUpdateNetworkErrorText: "Errore di rete durante l'aggiornamento bulk",
        deactivateRecordTitle: "Sei sicuro?",
        deactivateRecordText: "Questo deattiverà il record (SCD Type 2)",
        deactivateRecordConfirm: "Sì, deattiva il record!",
        deactivateRecordCancel: "No, annulla",
        deactivateSuccessTitle: "Deattivato",
        deactivateSuccessText: "Il record è stato deattivato",
        deactivateFailedTitle: "Errore",
        deactivateFailedText: "Non è stato possibile deattivare il record",
        importCompletedWithErrorsTitle: "Importazione completata con errori",
        importCompletedWithErrorsHtml: (deactivatedCount, importedCount, updatedCount, errorRows, response) => `
                          <div class="text-start">
                              <div class="alert alert-success mb-3">
                                  <p class="mb-1"><strong>Deattivati:</strong> ${deactivatedCount} record(s)</p>
                                  <p class="mb-1"><strong>Importati:</strong> ${importedCount} record(s)</p>
                                  <p class="mb-0"><strong>Aggiornati:</strong> ${updatedCount} record(s)</p>
                              </div>
                              <div class="alert alert-danger mb-3">
                                  <p class="mb-0"><strong>Errori:</strong> ${response.data.errors.length
            } record(s) con errori</p>
                              </div>
                              <div style="max-height: 400px; overflow-y: auto;">
                                  <table class="table table-sm table-bordered">
                                      <thead class="table-light sticky-top">
                                          <tr>
                                              <th style="width: 80px;">Rig</th>
                                              <th>Descrizione Errore</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          ${errorRows}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      `,
        importCompletedSuccessTitle: "Importazione completata con successo",
        importCompletedSuccessHtml: (deactivatedCount, importedCount, updatedCount, unchangedCount) => `
                                        <p><strong>Deattivati:</strong> ${deactivatedCount} record(s)</p>
                                        <p><strong>Importati:</strong> ${importedCount} record(s)</p>
                                        <p><strong>Aggiornati:</strong> ${updatedCount} record(s)</p>
                                        ${unchangedCount != null
                ? `<p><strong>Non modificati:</strong> ${unchangedCount} record(s)</p>`
                : ""
            }
                                    `,
        importFailedTitle: "Importazione fallita",
        importFailedText: "Non è stato possibile importare il file",
    },
    en: {
        missingRequiredTitle: "Missing required fields",
        missingRequiredIntro: "Please fill all fields before saving this new record:",
        discardChangesTitle: "Discard Changes?",
        discardChangesText: "You have unsaved changes. Are you sure you want to discard them?",
        discardConfirm: "Yes, discard",
        discardCancel: "No, keep editing",
        fetchVocabularyDataError: "Failed to fetch vocabulary data",
        recordSavedSuccessTitle: "Record saved successfully",
        recordSavedSuccessText: "The record has been saved successfully",
        recordSavedFailedTitle: "Error saving record",
        recordSavedFailedText: "The record has not been saved",
        noChangesTitle: "No changes",
        noChangesText: "No changes to save",
        saveChangesTitle: "Save Changes?",
        saveChangesConfirm: "Yes, save all!",
        saveChangesCancel: "Cancel",
        saveChangesHtml: (count) => `
              <p>You are about to save <strong>${count}</strong> record(s).</p>
              <p class="text-muted small">This operation will be performed as a single atomic transaction.</p>
            `,
        validationFailedTitle: "Validation Failed",
        validationFailedHtml: (count, errorRows) => `
          <div class="text-start">
            <p class="mb-2"><strong>${count}</strong> record(s) have missing required fields:</p>
            <div style="max-height: 300px; overflow-y: auto;">
              <table class="table table-sm table-bordered">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 80px;">Record</th>
                    <th style="width: 120px;">ID</th>
                    <th>Missing Fields</th>
                  </tr>
                </thead>
                <tbody>
                  ${errorRows}
                </tbody>
              </table>
            </div>
            <p class="mt-2 mb-0 text-muted small">Please complete the highlighted fields and try again.</p>
          </div>
        `,
        bulkUpdateCompletedWithErrorsTitle: "Bulk Update Completed with Errors",
        bulkUpdateCompletedWithErrorsHtml: (results, errorRows) => `
              <div class="text-start">
                <div class="alert alert-success mb-3">
                  <p class="mb-0"><strong>Updated:</strong> ${results.updated} record(s)</p>
                </div>
                <div class="alert alert-danger mb-3">
                  <p class="mb-0"><strong>Failed:</strong> ${results.failed} record(s)</p>
                </div>
                <div style="max-height: 300px; overflow-y: auto;">
                  <table class="table table-sm table-bordered">
                    <thead class="table-light sticky-top">
                      <tr>
                        <th style="width: 80px;">Record</th>
                        <th style="width: 120px;">ID</th>
                        <th>Error</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${errorRows}
                    </tbody>
                  </table>
                </div>
              </div>
            `,

        bulkUpdateSuccessTitle: "Success",
        bulkUpdateSuccessText: "record(s) saved successfully",
        bulkUpdateFailedTitle: "Bulk Update Failed",
        bulkUpdateFailedHtml: (response, results, errorRows) => `
          <div class="text-start">
            <div class="alert alert-danger mb-3">
              <p class="mb-0"><strong>${response.message || 'All records failed to save'}</strong></p>
            </div>
            <div class="alert alert-info mb-3">
              <p class="mb-1"><strong>Created:</strong> ${results.created || 0} record(s)</p>
              <p class="mb-1"><strong>Updated:</strong> ${results.updated || 0} record(s)</p>
              <p class="mb-0"><strong>Failed:</strong> ${results.failed || 0} record(s)</p>
            </div>
            <div style="max-height: 300px; overflow-y: auto;">
              <table class="table table-sm table-bordered">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 80px;">Record</th>
                    <th style="width: 120px;">ID</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  ${errorRows}
                </tbody>
              </table>
            </div>
          </div>
        `,
        validationErrorNoObjectHtml: (response, errorList) => `
              <div class="text-start">
                <p class="mb-2">${response.message || 'Please correct the following errors:'}</p>
                <ul class="list-unstyled">
                  ${errorList}
                </ul>
              </div>
            `,
        bulkUpdateNetworkErrorText: "Network error during bulk update",
        deactivateRecordTitle: "Are you sure?",
        deactivateRecordText: "This will deactivate the record (SCD Type 2)",
        deactivateRecordConfirm: "Yes, deactivate it!",
        deactivateRecordCancel: "No, cancel",
        deactivateSuccessTitle: "Deactivated",
        deactivateSuccessText: "Record has been deactivated",
        deactivateFailedTitle: "Error",
        deactivateFailedText: "Failed to deactivate record",
        importCompletedWithErrorsTitle: "Import Completed with Errors",
        importCompletedWithErrorsHtml: (deactivatedCount, importedCount, updatedCount, errorRows, response) => `
                          <div class="text-start">
                              <div class="alert alert-success mb-3">
                                  <p class="mb-1"><strong>Deactivated:</strong> ${deactivatedCount} old records</p>
                                  <p class="mb-1"><strong>Imported:</strong> ${importedCount} new records</p>
                                  <p class="mb-0"><strong>Updated:</strong> ${updatedCount} records</p>
                              </div>
                              <div class="alert alert-danger mb-3">
                                  <p class="mb-0"><strong>Errors:</strong> ${response.data.errors.length
            } rows with errors</p>
                              </div>
                              <div style="max-height: 400px; overflow-y: auto;">
                                  <table class="table table-sm table-bordered">
                                      <thead class="table-light sticky-top">
                                          <tr>
                                              <th style="width: 80px;">Row</th>
                                              <th>Error Description</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          ${errorRows}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      `,
        importCompletedSuccessTitle: "Import Successful",
        importCompletedSuccessHtml: (deactivatedCount, importedCount, updatedCount, unchangedCount) => `
                          <p><strong>Deactivated:</strong> ${deactivatedCount} old records</p>
                          <p><strong>Imported:</strong> ${importedCount} new records</p>
                          <p><strong>Updated:</strong> ${updatedCount} records</p>
                          ${unchangedCount != null
                ? `<p><strong>Unchanged:</strong> ${unchangedCount} records</p>`
                : ""
            }
                      `,
        importFailedTitle: "Import Failed",
        importFailedText: "Failed to import file",
    }
};

export const HandleSaveRowSwal = (missingList,) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.missingRequiredTitle,
        html: `
          <div class="text-start">
            <p class="mb-2">${L.missingRequiredIntro}</p>
            <ul class="list-unstyled">${missingList}</ul>
          </div>
        `,
        width: "600px",
    });
}

export const handleCancelEditSwal = () => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        title: L.discardChangesTitle,
        text: L.discardChangesText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: L.discardConfirm,
        cancelButtonText: L.discardCancel,
    });
}

export const fetchVocabularyDataSwal = (response) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: "Error",
        text: response.message || L.fetchVocabularyDataError,
    });
}

export const handleSaveRowSwal = (missingList) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.missingRequiredTitle,
        html: `
          <div class="text-start">
            <p class="mb-2">${L.missingRequiredIntro}</p>
            <ul class="list-unstyled">${missingList}</ul>
          </div>
        `,
        width: "600px",
    });
}

export const recordSavedSuccessSwal = () => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "success",
        title: L.recordSavedSuccessTitle,
        text: L.recordSavedSuccessText,
    });
}

export const recordSavedFailedSwal = (response) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.recordSavedFailedTitle,
        text: response.message || L.recordSavedFailedText,
    });
}

export const handleSaveChangesSwal = () => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "info",
        title: L.noChangesTitle,
        text: L.noChangesText,
        timer: 2000,
    });
}

export const handleSaveChangesConfirmSwal = (modifiedRows) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({

        title: L.saveChangesTitle,
        html: L.saveChangesHtml(modifiedRows.length),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: L.saveChangesConfirm,
        cancelButtonText: L.saveChangesCancel,
    });
}

export const validationFailedErrorSwal = (invalids, errorRows) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.validationFailedTitle,
        html: L.validationFailedHtml(invalids.length, errorRows),
        width: "800px",
    });
}

export const bulkUpdateCompletedWithErrorsSwal = (results, errorRows) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({

        icon: "warning",
        title: L.bulkUpdateCompletedWithErrorsTitle,
        html: L.bulkUpdateCompletedWithErrorsHtml(results, errorRows),
        width: "800px",

    });
}

export const bulkUpdateSuccessSwal = (response, modifiedRows) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "success",
        title: L.bulkUpdateSuccessTitle,
        text: response.message || `${modifiedRows.length} ${L.bulkUpdateSuccessText}`,
        timer: 2000,
    });
}

export const bulkUpdateFailedSwal = (response, results, errorRows) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.bulkUpdateFailedTitle,
        html: L.bulkUpdateFailedHtml(response, results, errorRows),
        width: "800px",
    });
}

export const validationErrorNoObjectSwal = (response, errorList) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.validationFailedTitle,
        html: L.validationErrorNoObjectHtml(response, errorList),
        width: "600px",
    });
}

export const bulkUpdateNetworkErrorSwal = (error) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: "Error",
        text: error.message || L.bulkUpdateNetworkErrorText,
    });
}

export const deactivateRecordSwal = () => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        title: L.deactivateRecordTitle,
        text: L.deactivateRecordText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: L.deactivateRecordConfirm,
        cancelButtonText: L.deactivateRecordCancel,
    });
}

export const deactivateSuccessSwal = () => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "success",
        title: L.deactivateSuccessTitle,
        text: L.deactivateSuccessText,
        timer: 2000,

    });
}

export const deactivateFailedSwal = (response) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.deactivateFailedTitle,
        text: response.message || L.deactivateFailedText,
    });
}

export const importCompletedWithErrorsSwal = (deactivatedCount, importedCount, updatedCount, errorRows, response) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "warning",
        title: L.importCompletedWithErrorsTitle,
        html: L.importCompletedWithErrorsHtml(deactivatedCount, importedCount, updatedCount, errorRows, response),
        width: "800px",
        showConfirmButton: true,
    });
}

export const importCompletedSuccessSwal = (deactivatedCount, importedCount, updatedCount, unchangedCount) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "success",
        title: L.importCompletedSuccessTitle,
        html: L.importCompletedSuccessHtml(deactivatedCount, importedCount, updatedCount, unchangedCount),
        timer: 3000,
    });
}

export const importFailedSwal = (response) => {
    const lang = resolveLang();
    const L = modalTexts[lang];
    return ({
        icon: "error",
        title: L.importFailedTitle,
        text: response.message || L.importFailedText,
      });
}